import React, { useState } from 'react';
import { Box, Button, Grid2, Typography } from '@mui/material';
import Menu from '../Menu/Menu';
import './Header.css';
import myImage from "../../assets/images/Logo.png";

const Header: React.FC = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleDrawer = (open: boolean) => (event: React.KeyboardEvent | React.MouseEvent) => {
    if (
        event &&
        event.type === 'keydown' &&
        ((event as React.KeyboardEvent).key === 'Tab' || (event as React.KeyboardEvent).key === 'Shift')
    ) {
      return;
    }
    setIsOpen(open);
  };

  return (
      <Grid2 className='header'>
        <Grid2 className='header-inner'>
          <Box>
              <img
                  src={myImage}
                  alt="8Rabbits"
                  style={{
                      // width: '100%',
                      height: '100%',
                      position: 'absolute',
                      top: 0,
                      // left: 0,
                      display: 'block',
                  }}
              />
          </Box>
          {!isOpen &&
              <Button className='button-header-menu' onClick={toggleDrawer(true)}>
                <Typography className="capitalize-first-letter">Menu</Typography>
                <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 25 24" fill="none">
                  <path d="M3.5 18V16H21.5V18H3.5ZM3.5 13V11H21.5V13H3.5ZM3.5 8V6H21.5V8H3.5Z" fill="white"/>
                </svg>
              </Button>
          }
        </Grid2>
        {<Menu isOpen={isOpen} toggleDrawer={toggleDrawer}/>}
      </Grid2>
  );
};

export default Header;
